import Date from '../../date/Date';

export default class KindergartenConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const config = new KindergartenConfig();
        config.id = data.id;
        config.basfiNumber = data.basfiNumber ?? '';
        config.hasReports = data.hasReports;
        config.costUnit = data.kindergarten.costUnits.find((c) => c.id === data.costUnit) || null;
        config.kindergarten = data.kindergarten;
        config.status = data.status;
        config.hasPersistedCostUnit = data.costUnit !== null;
        config.start = data.start === null ? null : Date.fromIso8601(data.start);
        config.enabled = data.enabled;

        return config;
    }

    getNextReportDate() {
        if (this.start === null && !this.isEnabled()) {
            return null;
        }
        const today = Date.today();
        const nextRegular = today.day >= 2 ? today.addMonths(1) : today;
        nextRegular.day = 2;
        return nextRegular.isBeforeOrEqual(this.start) ? this.start : nextRegular;
    }

    isEnabled() {
        return this.status === 'enabled';
    }

    isPaused() {
        return this.status === 'paused';
    }

    isIncomplete() {
        return this.status === 'incomplete';
    }

    serialize() {
        {
            return {
                kindergarten: this.kindergarten.id,
                basfiNumber: this.basfiNumber,
                start: this.start === null ? null : this.start.toIso8601(),
                enabled: this.enabled,
                costUnit: this.costUnit ? this.costUnit.id : null,
                subventionsEnabled: this.kindergarten.subventionsEnabled,
            };
        }
    }
}
